import { useCurrentUser } from 'api'
import { useLocalization } from 'localization'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { URL_KEY_MAP } from './consts'

export const useMainMenu = () => {
	const { t } = useLocalization()
	const router = useRouter()
	const { isCPAview, data: user, isFetched } = useCurrentUser()

	const currentMenuKey = useMemo(() => {
		const foundKey = Object.keys(URL_KEY_MAP).find(key => {
			const firstUrlPath = router.pathname.split('/')[1]
			return key === `/${firstUrlPath}`
		})
		return foundKey ? URL_KEY_MAP[foundKey].toString() : undefined
	}, [router.pathname])

	return { currentMenuKey, t, router, isCPAview, user, isFetched }
}
